import { ChangeDetectorRef, Component, OnInit,OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { forkJoin, merge, Subscription } from 'rxjs';

@Component({
  selector: 'app-non-enumerated-individual-details',
  templateUrl: './non-enumerated-individual-details.component.html',
  styleUrls: ['./non-enumerated-individual-details.component.css','../shared/css/common.css']
})
export class NonEnumeratedIndividualDetailsComponent implements OnInit, OnDestroy {

  nonEnumeratedIndividualFormData: any;
  formdata: any | null;
  payorkey: number;
  title: string = "Provider";
  isformloaded = false;
  isInstruction = false;
  instructionText!: string | null;

  nonEnumeratedIndividualFormData1: any = {};
  nonEnumeratedIndividualFormData2: any = {};
  internalInvolvedPartiesKey = 0;
  isNameRequired = false;
  isRequiredIdLabelVisible = false;
  isFormsValid = false;
  statelist: StateNames[] = [];
  primaryColor?: string = "";

  nonEnumeratedIndividualFormPart1: FormGroup;
  nonEnumeratedIndividualFormPart2: FormGroup;
  private nameSubscription?: Subscription;
  private stateSubscription?: Subscription;
  private formSubscription?: Subscription;
  private initCount = 0;

  @Input() inputDetails: any;
  @Output() formValidationEvent: EventEmitter<{isValid:boolean, isChanged: boolean}> = new EventEmitter();
  
  constructor(
    private providerFormBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    this.nonEnumeratedIndividualFormPart1 = this.providerFormBuilder.group({});
    this.nonEnumeratedIndividualFormPart2 = this.providerFormBuilder.group({});
  }

  ngOnInit(): void {
    this.formdata = this.vendorService.getSessionData();
    this.nonEnumeratedIndividualFormData = this.inputDetails == null ? this.formdata.nonEnumeratedIndividualDetails : this.inputDetails;
    this.nonEnumeratedIndividualFormData1["controls"] = this.nonEnumeratedIndividualFormData.controls.slice(0, 11);
    this.nonEnumeratedIndividualFormData2["controls"] = this.nonEnumeratedIndividualFormData.controls.slice(11, 21);
    let currentUrl = window.location.hash;
    if(currentUrl.includes('additionalInvolvedParties')) {
      const involvedCtrl = this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "additionalInvolvedType");
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }
    else {
      const involvedCtrl = this.formdata.witnessDetails.controls.find((x: { name: string }) => x.name == 'involvedType');
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }
    
    this.vendorService.getLeadHeaders(this.payorkey).subscribe(result => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction?.replace('<img ', '<img title="Header" ');
      this.instructionText = instructionText;
    });

    let getStatesApi = this.vendorService.getStateNames();
    let getSubjectRequiredFieldApi = this.vendorService.getSubjectRequiredFieldsByInvolvedParty(this.internalInvolvedPartiesKey, this.payorkey);
    forkJoin([getSubjectRequiredFieldApi, getStatesApi]).subscribe((response: any) => {
      let result = response[0];
      if(result.EitherOrOptions == 1)
        {
        this.isNameRequired = true;
      }        
      const markReq = (ctrlName: string, required: boolean) => {
        const ctrl = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === ctrlName)
          || this.nonEnumeratedIndividualFormData2.controls.find((x: any) => x.name === ctrlName);

        if (ctrl) ctrl.validators.required = required;
      };
      markReq("neiAssociatedOrg", !!result.AssociatedOrganizationName);
      markReq("neiFirstName", !!result.FirstName);
      markReq("neiLastName", !!result.LastName);
      markReq("neiMiddleName", !!result.MiddleName);
      markReq("neiDateOfBirth", !!result.DateofBirth);
      markReq("neiSsn", !!result.SSN);
      markReq("neiOtherId", !!result.OtherID);
      markReq("neiStreetAddress1", !!result.AddressLine1);
      markReq("neiCity", !!result.City);
      markReq("neiState", !!result.State);
      markReq("neiCounty", !!result.County);
      markReq("neiZip", !!result.ZipCode);
      markReq("neiCountry", !!result.Country);
      markReq("neiPrimaryPhone", !!result.Phone);
      markReq("neiSecondaryPhone", !!result.SecondaryPhone);
      markReq("neiEmail", !!result.Email);

      if(this.isNameRequired)
      {
        let firstnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiFirstName').value;
        let lastnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiLastName').value;
        let orgnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiAssociatedOrg').value;
        if ((firstnameVal && firstnameVal !== '') || (lastnameVal && lastnameVal !== '') ||
          (orgnameVal && orgnameVal !== '')) {
          this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = false;
          this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = false;
          this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = false;
        }
        else
        {
          this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = true;
          this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = true;
          this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = true;
        }
      }

      this.isformloaded = true;
      
      const countyValue = this.nonEnumeratedIndividualFormData2.controls.find((x: { name: string; }) => x.name == "neiCounty").value;
      this.statelist = response[1];
      this.nonEnumeratedIndividualFormData.controls.find((x: { name: string; }) => x.name == "neiState").options = response[1].map((x: any) => { return { "value": x.Abbreviation, "key": x.Name } });

      if (countyValue) {
        (this.nonEnumeratedIndividualFormPart2.get('neiCounty') as any)?.setValue(countyValue);
        this.cdref.detectChanges();
      }
      setTimeout(() => {
        if (countyValue) {
          (this.nonEnumeratedIndividualFormPart2.get('neiCounty') as any)?.setValue(countyValue);
          this.cdref.detectChanges();
        }
        setTimeout(() => {
          if (countyValue) {
            (this.nonEnumeratedIndividualFormPart2.get('neiCounty') as any)?.setValue(countyValue);
            this.cdref.detectChanges();
          }
        }, 1000);
      }, 1000);
    });

    setTimeout(() => {
      const color = localStorage.getItem('primaryCssColor');
      if (color) {
        this.primaryColor = color;
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    });
  }

  private applyRequiredValidators(result: any): void {
    const setReq = (group: FormGroup, field: string, required: boolean) => {
      const ctrl = group.get(field);
      if (!ctrl) return;
      if (required) ctrl.addValidators(Validators.required);
      else ctrl.removeValidators(Validators.required);
      ctrl.updateValueAndValidity({ emitEvent: false });
    };

    setReq(this.nonEnumeratedIndividualFormPart1, 'neiAssociatedOrg', !!result.AssociatedOrganizationName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiFirstName', !!result.FirstName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiLastName', !!result.LastName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiMiddleName', !!result.MiddleName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiDateOfBirth', !!result.DateofBirth);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiSsn', !!result.SSN);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiOtherId', !!result.OtherID);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiStreetAddress1', !!result.AddressLine1);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiCity', !!result.City);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiState', !!result.State);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiCounty', !!result.County);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiZip', !!result.ZipCode);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiCountry', !!result.Country);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiPrimaryPhone', !!result.Phone);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiSecondaryPhone', !!result.SecondaryPhone);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiEmail', !!result.Email);

    if(this.isNameRequired)
        {
        let firstnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiFirstName').value;
        let lastnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiLastName').value;
        let orgnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiAssociatedOrg').value;
        if ((firstnameVal && firstnameVal !== '') || (lastnameVal && lastnameVal !== '') ||
          (orgnameVal && orgnameVal !== '')) {
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = false;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = false;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = false;
          }
          else
          {
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = true;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = true;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = true;
          }
  
        }

  }

  private recheckFormValidity(): void {
    const allValid = this.nonEnumeratedIndividualFormPart1.valid && this.nonEnumeratedIndividualFormPart2.valid;
    if (this.isFormsValid !== allValid) {
      this.isFormsValid = allValid;
      this.cdref.detectChanges();
    }
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedIndividualFormData1.controls.concat(this.nonEnumeratedIndividualFormData2.controls);

    this.formdata.nonEnumeratedIndividualDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    let isFormChanged = this.nonEnumeratedIndividualFormPart1.dirty || this.nonEnumeratedIndividualFormPart2.dirty;
    this.formValidationEvent.emit({isValid: allValid, isChanged: isFormChanged});
  }

  childInitComplete(): void {
    this.initCount++;
    this.nonEnumeratedIndividualFormPart1.valueChanges.subscribe(() => this.recheckFormValidity());
    this.nonEnumeratedIndividualFormPart2.valueChanges.subscribe(() => this.recheckFormValidity());
    this.recheckFormValidity();
    this.cdref.detectChanges();
    if (this.initCount === 2) {
      this.setupSubscriptions();
    }
  }

  valueChange(data: any) {
    if (data?.name === 'neiState') {
      const abbrev = this.statelist.find(y => y.Id == data.value.target.selectedIndex)?.Abbreviation ?? "";
      this.vendorService.getStateCounties(abbrev).subscribe(result => {
        this.nonEnumeratedIndividualFormData.controls.find((x: any) => x.name == "neiCounty").options =
          result.map(x => ({ value: x.County, key: x.County }));
      });
      this.nonEnumeratedIndividualFormData.controls.find((x: any) => x.name == "neiCounty").disabled = false;
    }
    if (data?.name === 'neiDateOfBirth') {
      this.dobValidation();
    }
    this.formValidate(data);
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedIndividualFormData1.controls.concat(this.nonEnumeratedIndividualFormData2.controls);

    this.formdata.nonEnumeratedIndividualDetails = tempArr;
    this.vendorService.updateData(this.formdata);
  }

  formValidate(data: any) {
    this.isFormsValid = this.nonEnumeratedIndividualFormPart1.valid && this.nonEnumeratedIndividualFormPart2.valid && this.dobValidation();
  }

  nonEnumeratedIndividualDetailsSubmit() {
    if (this.isFormsValid) {
      const tempArr = {
        controls: [
          ...this.nonEnumeratedIndividualFormData1.controls,
          ...this.nonEnumeratedIndividualFormData2.controls
        ]
      };
      this.formdata.nonEnumeratedIndividualDetails = tempArr;
    this.vendorService.updateData(this.formdata);
      this.router.navigate(['validateParticipant']);
    }
  }

  back() {
    const tempArr = {
      controls: [
        ...this.nonEnumeratedIndividualFormData1.controls,
        ...this.nonEnumeratedIndividualFormData2.controls
      ]
    };
    this.formdata.nonEnumeratedIndividualDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    this.router.navigate(['involvedParties']);
  }

  openInstruction() {
    const result = this.modalService.open(InstructionsComponent, {
      size: 'lg',
      ariaLabelledBy: 'Instructions'
    });
    result.componentInstance.name = this.instructionText;
  }
   private setupSubscriptions() {
    if (this.isNameRequired) {
      const firstCtrl = this.nonEnumeratedIndividualFormPart1.get('neiFirstName');
      const lastCtrl = this.nonEnumeratedIndividualFormPart1.get('neiLastName');
      const orgCtrl = this.nonEnumeratedIndividualFormPart1.get('neiAssociatedOrg');

      if (firstCtrl && lastCtrl && orgCtrl) {
        this.nameSubscription = merge(
          firstCtrl.valueChanges,
          lastCtrl.valueChanges,
          orgCtrl.valueChanges
        ).subscribe(() => {
          this.updateNameValidators();
        });
      }
    }
    const stateCtrl = this.nonEnumeratedIndividualFormPart2.get('neiState');
    if (stateCtrl) {
      this.stateSubscription = stateCtrl.valueChanges.subscribe((abbr: any) => {
        if (abbr) {
          this.loadCounties(abbr);
        }
      });
    }
    this.formSubscription = merge(
      this.nonEnumeratedIndividualFormPart1.valueChanges,
      this.nonEnumeratedIndividualFormPart2.valueChanges
    ).subscribe(() => {
      this.formValidate(null);
    });

    if (this.isNameRequired) {
      this.updateNameValidators();
    }

    const initialStateValue = stateCtrl?.value;
    if (initialStateValue) {
      this.loadCounties(initialStateValue);
    }
  }

  private loadCounties(abbr: string) {
    this.vendorService.getStateCounties(abbr).subscribe((result: any[]) => {
      const countyConfig = this.nonEnumeratedIndividualFormData.controls.find( (x: any) => x.name === "neiCounty");
      if (!countyConfig) return;
      const counties = result.map(x => ({ key: x.County, value: x.County }));
      countyConfig.options = counties;
      countyConfig.disabled = false;

      setTimeout(() => {
        const countyCtrl = this.nonEnumeratedIndividualFormPart2.get('neiCounty');
        if (countyCtrl) {
          (countyCtrl as any).setValue('');
          countyConfig.value = '';
          countyCtrl.markAsPristine();
          countyCtrl.markAsUntouched();
        }
      }, 0);
    });
  }

    private updateNameValidators() {
    if (!this.isNameRequired) return;

    const firstVal = this.nonEnumeratedIndividualFormPart1.get('neiFirstName')?.value;
    const lastVal = this.nonEnumeratedIndividualFormPart1.get('neiLastName')?.value;
    const orgVal = this.nonEnumeratedIndividualFormPart1.get('neiAssociatedOrg')?.value;

    const hasAny = !!(firstVal || lastVal || orgVal);

    const firstCtrl = this.nonEnumeratedIndividualFormPart1.get('neiFirstName');
    const lastCtrl = this.nonEnumeratedIndividualFormPart1.get('neiLastName');
    const orgCtrl = this.nonEnumeratedIndividualFormPart1.get('neiAssociatedOrg');

    if (hasAny) {
      firstCtrl?.clearValidators();
      lastCtrl?.clearValidators();
      orgCtrl?.clearValidators();

      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = false;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = false;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = false;
    } else {
      firstCtrl?.setValidators([Validators.required]);
      lastCtrl?.setValidators([Validators.required]);
      orgCtrl?.setValidators([Validators.required]);

      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = true;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = true;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = true;
    }

    firstCtrl?.updateValueAndValidity({ emitEvent: false });
    lastCtrl?.updateValueAndValidity({ emitEvent: false });
    orgCtrl?.updateValueAndValidity({ emitEvent: false });

    this.formValidate(null);
  }

  ngOnDestroy() {
    this.nameSubscription?.unsubscribe();
    this.stateSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();
  }
  private dobValidation(): boolean {
    let result = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dobCfg = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiDateOfBirth')
      || this.nonEnumeratedIndividualFormData2.controls.find((x: any) => x.name === 'neiDateOfBirth');

    const dob = dobCfg && dobCfg.value ? new Date(dobCfg.value) : null;
    let err = '';
    if (dob && dob > today) {
      err = 'Date cannot be in the future.';
      result = false;
    }

    const el = document.getElementById('neiDateOfBirth_Error');
    if (el) el.textContent = err;

    const ctrl = this.nonEnumeratedIndividualFormPart1.get('neiDateOfBirth') || this.nonEnumeratedIndividualFormPart2.get('neiDateOfBirth');
    if (ctrl) {
      if (!result) {
        ctrl.setErrors({ ...(ctrl.errors || {}), futureDate: true });
      } else {
        if (ctrl.errors && ctrl.errors['futureDate']) {
          const { futureDate, ...rest } = ctrl.errors;
          Object.keys(rest).length ? ctrl.setErrors(rest) : ctrl.setErrors(null);
        }
      }
    }
    return result;
  }
}
